import colors from "@/constants/Colors";
import { useThemeColor } from "@/hooks/useThemeColor";
import { text } from "@/constants/Styles";

export const useMarkdownStyles = () => {    
    const textColor = useThemeColor({light: 'black', dark: 'white'}, 'text');
    
    return {
        heading1: {
            fontSize: undefined,
        },
        heading2: {
            fontSize: undefined,
        },
        heading3: {
            fontSize: undefined,
        },
        heading4: {
            fontSize: undefined,
        },
        heading5: {
            fontSize: undefined,
        },
        heading6: {
            fontSize: undefined,
        },
        paragraph: {
          marginTop:0,
          marginBottom:0,
          fontSize: text.p.fontSize,
        },
        link: {
          textDecorationLine: 'none',
        },
        table: {
          borderWidth: 1,
          borderColor: colors.muted['500'],
          borderBottomWidth: 0,
          borderRightWidth: 0,
        },
        thead: {
        },
        tbody: {},
        th: {
          flex: 1,
          padding: 10,
          backgroundColor: colors.muted['200'],
          borderRightWidth: 1,
          borderRightColor: colors.muted['500']
        },
        tr: {
          borderBottomWidth: 1,
          borderColor: colors.muted['500'],
          flexDirection: 'row',
        },
        td: {
          flex: 1,
          padding: 10,
          borderRightWidth: 1,
          borderRightColor: colors.muted['500']
        },
        list_item: {
            color: textColor,
            fontSize: text.p.fontSize,
        },
        bullet_list_content: {
            color: textColor,
            fontSize: text.p.fontSize,
        }
      };
}